import { createAsyncThunk } from '@reduxjs/toolkit';
import { SEND_REVIEW_DATA } from '@custom/constant'; // Assuming you have a constant for the URL
import { SendForReviewPayload } from '@custom/Utils/constants/interfaces';

const sendForReview = createAsyncThunk(
  'report/sendForReview',
  async (data: SendForReviewPayload) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = SEND_REVIEW_DATA; // Define your API endpoint
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Return the response data
      return await response.json();
    } catch (error) {
      // Handle and return the error
      return Promise.reject(error);
    }
  }
);

export default sendForReview;
